import { SPRITESHEET_UI } from "Data/Constants";
import { getTexture } from "html-living-framework/lib/Utils/PixiUtils";
import { Emitter } from "pixi-particles";

export class MusicNoteParticleSystem extends PIXI.Container  {
    protected _emitter!: Emitter;
    constructor() {
        super();
        this._emitter = new Emitter(this, [
            getTexture("music-note-01-02-02", SPRITESHEET_UI),
            getTexture("music-note-00-02-02", SPRITESHEET_UI),
        ], {
            alpha: {
                list: [
                    { value: 0, time: 0 },
                    { value: 1, time: 0.2 },
                    { value: 1, time: 0.8 },
                    { value: 0, time: 1 },
                ],
            },
            scale: {
                list: [
                    { value: 0.1, time: 0 },
                    { value: 1, time: 1 },
                ],
            },
            speed: {
                list: [
                    { value: 200, time: 0 },
                    { value: 100, time: 1 },
                ],
            },
            startRotation: { min: 0, max: 360 },
            // minStartRotation: 0,
            // maxStartRotation: 360,
            lifetime: { min: 0.3, max: 0.8 },
            frequency: 0.008,
            emitterLifetime: 0.2,
            maxParticles: 1000,
            pos: { x: 0, y: 0 },
            addAtBack: false,
            spawnType: "polygonalChain",
            spawnPolygon: [
                {x: -400, y: 50},
                {x: -400, y: -150},
                {x: 350, y: -150},
                {x: 400, y: 0},
            ],
            blendMode: "normal",
            autoUpdate: true,
        });

        this.stopEmitting();
    }

    public startEmitting(): void {
        this._emitter.emit = true;
    }

    public stopEmitting(): void {
        this._emitter.emit = false;
    }

    public updateSpawnPosition(pPoint: PIXI.Point): void {
        this._emitter.updateSpawnPos(pPoint.x, pPoint.y);
    }
}
